/**
 * GroupType
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import {
  GROUPTYPE_KEYS,
  GROUPTYPES_GENERAL,
  GROUPTYPES_CLASS,
  BETA_MODULES_INBOX,
} from 'containers/User/constants.js';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import CheckMark from 'components/media/Icon2/CheckMark.jsx';
import ColorBlock from 'components/media/ColorBlock/index.js';
import SearchInfo from 'components/interaction/Search/SearchInfo.jsx';
import messages from './messages.js';
import ChildGroups from './ChildGroups.jsx';
import AdminList from '../AdminList.jsx';
import useSearchableList from '../useSearchableList.js';
import AdminHeader from '../AdminHeader.jsx';
import InboxesSwitch from './InboxesSwitch.jsx';

function getShowMembers(type) {
  return type === undefined || [GROUPTYPES_CLASS, GROUPTYPES_GENERAL].includes(type);
}

function GroupType(props) {
  const { type, search, control } = props;
  const { id, key, intro } = type;
  const url = `sa/groups?groupType=${GROUPTYPE_KEYS[id]}`;
  const selector = `sa/groups/${id}`;
  const showMembers = getShowMembers(key);
  const role = useCurrentRole();
  const withInboxes = role.school.betaModules?.includes(BETA_MODULES_INBOX);

  const header = (
    <thead>
      <tr>
        <th className="narrow">&nbsp;</th>
        <th className="name"><FormattedMessage {...messages.name} /></th>
        {showMembers && <th><FormattedMessage {...messages.members} /></th>}
        {showMembers && <th className="sub-groups">&nbsp;</th>}
        <th><FormattedMessage {...messages.conversations} /></th>
      </tr>
    </thead>
  );

  function renderRow(item) {
    return (
      <tr key={item.id}>
        <td className="narrow">
          <ColorBlock color={item.theme?.themeColor} />
        </td>
        <td className="name">
          <Link to={`/admin/groups/${id}/${item.id}`}>{item.name}</Link>
        </td>
        {showMembers && <td><span className="num">{item.memberCount}</span></td>}
        {showMembers && <td className="sub-groups"><ChildGroups group={item} /></td>}
        <td><CheckMark value={item.groupOptions.topics} /></td>
      </tr>
    );
  }

  const { items, list } = useSearchableList({ search, url, selector, version: 2, clientSearch: true });

  return (
    <Card>
      <AdminHeader
        title={messages[id]}
        control={control}
        intro={intro}
        count={list.length}
      />
      {withInboxes && type.key === GROUPTYPES_CLASS && <InboxesSwitch className="mx-4" /> }
      <SearchInfo className="mx-4" search={search} />
      <AdminList
        resetKey={`${search}_${id}`}
        items={items}
        list={list}
        emptyMessage={messages.noGroups}
        header={header}
        renderRow={renderRow}
      />
    </Card>
  );
}

GroupType.propTypes = {
  search: PropTypes.string,
  type: PropTypes.object.isRequired,
  control: PropTypes.node,
};

export default GroupType;
